import {Ttm} from './ttm';

export class TtmStatus {
    key: string;
    name: string;
    color: string;
    color_group: number;
    show_in_overview: boolean;
    for_any: boolean;
    for_permanent: boolean;
    for_rolling_equipment: boolean;
    ask_weighting: boolean;
    for_check: boolean;
    order?: number;
    ttms?: Ttm[];
    successive: TtmStatus[];

    pivot?: {
        order?: number;
    }
}
